var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGermany = function SvgGermany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 511.99 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M15.93 345C52.1 442.6 145.92 512 256 512s203.9-69.4 240.07-167L256 322.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d3d3d",
    d: "M256 0C145.92 0 52.1 69.4 15.93 167L256 189.15 496.07 167C459.9 69.55 366.07 0 256 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M15.93 167a256.75 256.75 0 0 0 0 178.06h480.13a256.75 256.75 0 0 0 0-178.06z"
  })));
};
export default SvgGermany;